module.exports = __webpack_public_path__ + "3bc7f3b9927fbb822745a7a337cca4f8.pdf";